/* ── Search Overlay Toggle & AJAX Search ── */
(function() {
  function initSearch() {
    var searchBtns = document.querySelectorAll('.header__search-trigger');
    var searchOverlay = document.getElementById('header-search-overlay');
    var searchClose = document.getElementById('header-search-close');
    var searchInput = document.getElementById('header-search-input');
    var resultsContainer = document.getElementById('predictive-search-container');
    var staticResults = document.querySelector('.header__search-results');
    var searchForm = document.getElementById('header-search-form');

    if (searchBtns.length > 0 && searchOverlay) {
      searchBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (searchOverlay.classList.contains('is-open')) {
            closeSearch();
          } else {
            searchOverlay.classList.add('is-open');
            searchOverlay.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            if (searchInput) {
              setTimeout(function() { searchInput.focus(); }, 100);
            }
          }
        });
      });
    }


    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (searchInput) searchInput.value = '';
      if (resultsContainer) resultsContainer.innerHTML = '';
      if (staticResults) staticResults.style.display = '';
    }

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    var searchCancel = document.getElementById('header-search-cancel');
    if (searchCancel) searchCancel.addEventListener('click', closeSearch);

    /* Close search on clicking outside the results area */
    if (searchOverlay) {
      searchOverlay.addEventListener('click', function(e) {
        if (e.target === searchOverlay) {
          closeSearch();
        }
      });
    }

    /* Close search on Esc key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });

    /* ── AJAX Predictive Search ── */
    var debounceTimer;
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var query = searchInput.value.trim();
        clearTimeout(debounceTimer);

        if (query.length < 2) {
          if (resultsContainer) resultsContainer.innerHTML = '';
          if (staticResults) staticResults.style.display = '';
          return;
        }

        debounceTimer = setTimeout(function() {
          fetchResults(query);
        }, 300);
      });
    }

    function fetchResults(query) {
      if (!resultsContainer) return;
      
      // Show loading or hide static results
      if (staticResults) staticResults.style.display = 'none';
      resultsContainer.classList.add('is-loading');

      var url = '/search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&section_id=predictive-search';

      fetch(url)
        .then(function(response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var results = doc.getElementById('predictive-search-results');
          
          if (results) {
            resultsContainer.innerHTML = results.innerHTML;
          } else {
            resultsContainer.innerHTML = '<p class="predictive-search__no-results">No results found.</p>';
          }
          resultsContainer.classList.remove('is-loading');
        })
        .catch(function(error) {
          console.error('Search Error:', error);
          resultsContainer.classList.remove('is-loading');
        });
    }
  }

  document.addEventListener('DOMContentLoaded', initSearch);
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSearch);
  }
})();
